import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'brlCurrencyMask',
  standalone: false
})
export class BrlCurrencyMaskPipe implements PipeTransform {
  transform(value: any, includeSymbol: boolean = false): string {
    if (value == null || isNaN(value)) return '';

    return Number(value).toLocaleString('pt-BR', {
      style: includeSymbol ? 'currency' : 'decimal',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}
